import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ResolveTicketPopupData {
  ticketId: string;
  binderName: string;
  oldUser?: string;
  ticketUserId?: number;
  ticketUserName?: string;
  supportTicketId: number;
  userBinderId?: number;
  allocatedToUserId?: number | null;
  allocatedUserName?: string;
  allocatedUserEmail?: string;
  sku?: string;
  nfcCryptoId?: string;
  vaultxBinderNo?: number;
  isOtherCategory?: boolean;
}

@Component({
  selector: 'app-resolve-ticket-confirmation-popup',
  standalone: false,
  templateUrl: './resolve-ticket-confirmation-popup.html',
  styleUrls: ['./resolve-ticket-confirmation-popup.scss']
})
export class ResolveTicketConfirmationPopup {
  ticketId: string;
  binderName: string;
  sku: string;
  nfcCryptoId: string;
  vaultxBinderNo: number | null;
  allocatedToUserId: number | null;
  allocatedUserName: string;
  allocatedUserEmail: string;
  hasAllocatedUser: boolean;
  isOtherCategory: boolean;

  constructor(
    private readonly dialogRef: MatDialogRef<ResolveTicketConfirmationPopup>,
    @Inject(MAT_DIALOG_DATA) public data: ResolveTicketPopupData
  ) {
    this.ticketId = data.ticketId ;
    this.sku = data.sku ;
    this.nfcCryptoId = data.nfcCryptoId ;
    this.vaultxBinderNo = data.vaultxBinderNo ;
    this.binderName = data.binderName ;
    this.allocatedToUserId = data.allocatedToUserId;
    this.allocatedUserName = data.allocatedUserName ;
    this.allocatedUserEmail =  data.allocatedUserEmail;
    this.hasAllocatedUser = !!(this.allocatedToUserId && this.allocatedToUserId > 0);
    this.isOtherCategory = !!data.isOtherCategory;
  }

  close(): void {
    this.dialogRef.close({ confirm: false });
  }

  confirmResolution(): void {
    this.dialogRef.close({
      confirm: true,
      allocatedToUserId: this.allocatedToUserId
    });
  }
}

